<div fxLayout="column" fxLayoutAlign="center center" class="w250px">
  <h6 class="h6Title mgb40">Registrarse</h6>
  <br>

  <!-- <div class="inputContainer-last">
    <input type="email" class="form-control-full-width" placeholder="Email Address" #userEmail required>
  </div>

  <div class="inputContainer-last">
    <input type="password" class="form-control-full-width" placeholder="Password" #userPwd required>
  </div>

  <div class="inputContainer-last">
    <input type="button" class="blue-button-full-width" value="Registrarse"
      (click)="authService.SignUp(userEmail.value, userPwd.value)">
  </div> -->

  <div class="fw mgb10">
    <button type="button" class="fw redButton ft500 gray-2 fw shadow20" (click)="authService.GoogleAuth()">
      <i class="fab fa-google"></i>
      &nbsp;
      Registrarse con Google
    </button>
  </div>
  <!-- 
    <div class="fw mgb20">
      (click)="authService.FacebookAuth()"
      <button type="button" class="blueButton fw">
        <i class="fab fa-facebook"></i>
        &nbsp;
        Registrarse con Facebook
      </button>
    </div> -->

  <p class="centertext mgb0"> ¿Ya estas registrado? </p>
  <a class="blueLink ft500 centertext" [mat-dialog-close]="true" (click)="openSignIn()"> Iniciar
    sesión </a>

  <br>

</div>